<template>
    <div class="main">
        <div class="app-name">
            <rich-logo></rich-logo>
            <div>
                <h2>Rich'en Danse</h2>
                <p>Espace membre</p>
            </div>
        </div>
        <div class="connexion container">
            <div>
                <router-link style="margin-bottom: 16px;" to="/connexion">Retour</router-link>
                <h1>Réinitialisation du mot de passe</h1>

                <ValidationObserver ref="observerPassword"
                                    v-slot="{ invalid }"
                                    tag="form"
                                    @submit.prevent="submitPassword()"
                                    class="form-container">
                    <ValidationProvider
                            name="password"
                            rules="required|passwordCheck"
                            v-slot="{ errors }"
                    >
                        <uni-input-container label="Mot de passe" id="password">
                            <uni-input-password v-model="family.password" id="password"/>
                        </uni-input-container>
                        <span class="message-error">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider
                            rules="required|confirmed:password"
                            v-slot="{ errors }"
                    >
                        <uni-input-container label="Confirmez le mot de passe" id="confirm">
                            <uni-input-password v-model="family.password_confirmation" id="confirm"/>
                        </uni-input-container>
                        <span class="message-error">{{ errors[0] }}</span>

                    </ValidationProvider>
                    <div class="card">
                        <p>
                            Votre mot de passe doit contenir au minimum
                        </p>
                        <ul style="list-style: unset">
                            <li>
                                8 caractères
                            </li>
                            <li>
                                une majuscule
                            </li>
                            <li>
                                un chiffre
                            </li>
                        </ul>
                    </div>
                    <info-message v-if="isAttemptAnError">
                        Une erreur est survenue. Veuillez reessayer.
                    </info-message>
                    <info-message status="success" v-if="isEmailSend">
                        Votre mot de passe a bien été modifié.
                    </info-message>

                    <uni-loading-button style="margin-top: 16px;" :is-disable="loading" text="Réinitialiser"/>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
    import RichLogo from "../../components/a-elements/RichLogo";
    import UniInputContainer from "../../components/a-elements/UniInputContainer";
    import UniInput from "../../components/a-elements/UniInput";
    import InfoMessage from "../../components/a-elements/InfoMessage";
    import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";
    import UniInputPassword from "../../components/a-elements/UniInputPassword";

    export default {
        name: "recoverEdit",
        components: {UniInputPassword, UniLoadingButton, InfoMessage, UniInput, UniInputContainer, RichLogo},
        data() {
            return {
                loading: false,
                buttonIsLoading: false,
                isErrorWithAdress: false,

                isAttemptAnError: false,
                isEmailSend: false,
                family: {
                    password: '',
                    password_confirmation: '',
                    id: this.$route.params.id,
                    recover_password: this.$route.params.token
                }
            }
        },
        methods: {
            async submitPassword() {
                this.loading = true
                const isValid = await this.$refs.observerPassword.validate();
                if (!isValid) {
                    // ABORT!!
                    console.log('Form is uncomplete')
                } else {
                    this.$http.post('/recover-password-confirm?id='+this.family.id, {family: this.family})
                        .then(response => {
                            this.$router.push({name: 'Login', params: {init: 'true'}})
                        })
                        .catch(error => {
                            this.isAttemptAnError = true
                        })
                        .finally(() => {
                            this.loading = false
                        })


                }
            },
        },

        created() {
            // if (!this.$route.params.id && !this.$route.params.token) {
            //     this.$router.push('/connexion')
            // }
        }
    }
</script>

<style lang="scss" scoped>
    .main {
        height: 100vh;
    }


    .connexion {
        max-width: 450px;
        width: 100%;
        margin: 0 auto;
        background: var(--surface-color-light);

        h1 {
            margin-bottom: var(--s-xl);
        }

        &__new {
            margin-top: var(--s-xxl);
            text-align: center;
        }
    }

    .pub {
        display: none;
    }

    .app-name {
        display: flex;
        align-items: center;
        margin-bottom: 32px;
        padding: 8px;

        > div {
            p {
                margin-bottom: 0;
            }

            h2 {
                line-height: 16px;
                margin-bottom: 0;
            }
        }
    }

    .pub-uni {
        position: fixed;
        padding: 8px;
    }

    @include screen-xs {
        .pub-uni {
            padding: 16px;
        }
        .app-name {
            padding: 16px;
        }
    }

    @include screen-l {
        .main {
            .pub-uni {
                bottom: 24px;
                padding: 16px 24px;
            }
        }

        .app-name {
            margin-bottom: 84px;
            padding: 16px 24px;
        }

    }
</style>
